export default __webpack_public_path__ + "static/img-handle-all-optimize-experience-b28cfa267aee3bf8ea3b9535853d3fc7.png";